import { Controller } from "@hotwired/stimulus"
import { numberToCurrency } from "utils"

export default class extends Controller {
  static values = {
    allowSubDollarAmount: { default: false, type: Boolean },
    buttonText: { default: "Pay", type: String },
  }
  static targets = ["text", "amount"]

  updateButton() {
    this.textTarget.textContent = `${this.buttonTextValue} ${numberToCurrency(this.amountTarget.value)}`

    const validSubDollarAmount = this.allowSubDollarAmountValue && this.amountTarget.value > 0
    if (validSubDollarAmount || this.amountTarget.value >= 1) {
      this.textTarget.closest("button").removeAttribute("disabled")
    } else {
      this.textTarget.closest("button").setAttribute("disabled", "disabled")
    }
  }

  updateAmount(e) {
    const number = Number(e.currentTarget.value)
    this.amountTarget.value = number
    this.updateButton()
  }

  connect() {
    this.updateButton()
  }
}
